export const CyLivePositionMarker = {
  Marker: "LivePositionMarker",
} as const;
